var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as Chartist from 'chartist';
import { BaseChart } from '../base-chart';
var ChartistPie = /** @class */ (function (_super) {
    __extends(ChartistPie, _super);
    function ChartistPie() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.pieConfig = {
            showLabel: false,
            chartPadding: 0
        };
        return _this;
    }
    ChartistPie.prototype.generate = function () {
        this.chart = new Chartist.Pie(this.config.selector, this.transformChartData(), this.pieConfig);
    };
    ChartistPie.prototype.transformChartData = function () {
        return {
            labels: this.config.labels,
            series: this.config.data,
        };
    };
    ChartistPie.prototype.destroy = function () {
        if (this.chart) {
            this.chart.detach();
        }
    };
    return ChartistPie;
}(BaseChart));
export { ChartistPie };
